// extracted by mini-css-extract-plugin
export var blockLink = "style-module--blockLink--ec6fa";
export var cardBody = "style-module--cardBody--9490d";
export var cardWrapper = "style-module--cardWrapper--a85af";
export var ctaWrapper = "style-module--ctaWrapper--58174";
export var linkWrapper = "style-module--linkWrapper--99270";
export var promotionItems = "style-module--promotionItems--a199d";
export var titleLink = "style-module--titleLink--1edf8";